import { Type } from 'class-transformer';

export class AnnouncementsResultDto {
    announcementId: number;
    title: string;
    content: string;
    createdBy: string;
    contextName: string;

    @Type(() => Date)
    createdOn: Date;

    @Type(() => Date)
    releaseDate: Date;

    @Type(() => Date)
    expires: Date;

    allowEdit: boolean;
    allowDelete: boolean;
}
